var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"upload-dados"}},[_c('v-container',[_c('v-card',{staticClass:"py-4 px-1",attrs:{"tile":""}},[_c('page-title',{attrs:{"main":"Administração","icon":"mdi-pencil-box-outline","sub":"Upload de dados no banco","home":"/administracao"}}),_c('form-dados')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }